<script setup lang="ts">
import { becomeAuthorSchema } from '~/utils/crystallize/become-author'

definePageMeta({
  name: 'become-author',
  layout: false,
  colorMode: 'light',
  theme: 'blurple',
})

const options = useCatalogueQueryOptions({
  path: '/bli-forfatter',
  schema: becomeAuthorSchema,
})

const { data, suspense } = useQuery(options)

await suspense()

useHead({
  htmlAttrs: {
    class: 'bg-carbon-50',
  },
})

const editorsId = computed(() => data.value?.components?.editors ? 'editors' : undefined)

const contactButtonHref = computed(() => editorsId.value ? `#${editorsId.value}` : undefined)
</script>

<template>
  <NuxtLayout name="nettbutikk" :show-breadcrumbs="false">
    <article>
      <BecomeAuthorHeader
        :data="data?.components?.header"
        :contact-button-href="contactButtonHref"
      />

      <BecomeAuthorPublications v-if="data?.components?.publications" :data="data.components.publications" />

      <BecomeAuthorCta
        :data="data?.components?.contactCta"
        :contact-button-href="contactButtonHref"
        boxed
      />

      <BecomeAuthorAuthors :data="data?.components?.authors" />

      <ClientOnly>
        <BecomeAuthorHighlightedArticle :data="data?.components?.highlightedArticle" />
      </ClientOnly>

      <BecomeAuthorEditors :id="editorsId" :data="data?.components?.editors" />
    </article>
  </NuxtLayout>
</template>
